import { render, staticRenderFns } from "./DealifyHeader.vue?vue&type=template&id=6ae646a8&scoped=true"
import script from "./DealifyHeader.vue?vue&type=script&lang=js"
export * from "./DealifyHeader.vue?vue&type=script&lang=js"
import style0 from "./DealifyHeader.vue?vue&type=style&index=0&id=6ae646a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae646a8",
  null
  
)

export default component.exports